import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { User } from 'src/app/common-methods/models/user';

@Component({
  selector: 'app-custom-fields',
  templateUrl: './custom-fields.component.html',
  styleUrls: ['./custom-fields.component.css']
})
export class CustomFieldsComponent implements OnInit {
  @Input() mainForm: FormGroup;
  @Input() formArrName: string;
  userData = new User();

  constructor() { }

  ngOnInit() {
    this.userData = JSON.parse(sessionStorage.getItem('user_data'));
  }
  getMiscFormGroup() {
    const control = this.mainForm.get(this.formArrName) as FormArray;
    if (control) {
       return control.controls;
    }
    // return (this.mainForm.get(this.formArrName) as FormArray).controls;
  }

}
